"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSortState = exports.APTable = void 0;
var TableSortLabel_1 = __importDefault(require("@material-ui/core/TableSortLabel"));
var styles_1 = require("@material-ui/core/styles");
var TableCell_1 = __importDefault(require("@material-ui/core/TableCell"));
var SettingsOutlined_1 = __importDefault(require("@material-ui/icons/SettingsOutlined"));
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importStar(require("react"));
var react_virtualized_1 = require("react-virtualized");
var APFilterMenu_1 = require("../menus/APFilterMenu");
var APStack_1 = require("../layout/APStack");
var styles = function (theme) { return ({
    flexContainer: {
        display: 'flex',
        alignItems: 'center',
        boxSizing: 'border-box',
    },
    table: {
        // temporary right-to-left patch, waiting for
        // https://github.com/bvaughn/react-virtualized/issues/454
        '& .ReactVirtualized__Table__headerRow': {
            flip: false,
            paddingRight: theme.direction === 'rtl' ? '0 !important' : undefined,
            backgroundColor: 'none'
        },
    },
    tableRow: {
        cursor: 'pointer',
    },
    tableRowHover: {
        '&:hover': {
            backgroundColor: theme.palette.grey[200],
        },
    },
    tableRowNotEmpty: {
        backgroundColor: '#FFF',
        borderBottom: "1px solid #CDCDCD"
    },
    tableFirstRow: {
        borderTopLeftRadius: "15px",
        borderTopRightRadius: "15px",
    },
    tableLastRow: {
        borderBottomLeftRadius: "15px",
        borderBottomRightRadius: "15px",
    },
    tableRowEmpty: {
        backgroundColor: 'none'
    },
    tableCell: {
        flex: 1,
        border: 'none',
    },
    tableHeaderFlat: {
        flex: 1,
        border: 'none',
        borderBottom: "1px solid #CDCDCD",
        borderTop: "1px solid #CDCDCD"
    },
    tableHeaderRound: {
        flex: 1,
        border: 'none',
        borderTop: "1px solid #CDCDCD"
    },
    tableRowCell: {
        backgroundColor: "#FFF",
    },
    noClick: {
        cursor: 'initial',
    },
    height: "100%",
    overflowX: 'scroll'
}); };
var MuiVirtualizedTable = /** @class */ (function (_super) {
    __extends(MuiVirtualizedTable, _super);
    function MuiVirtualizedTable(props) {
        var _this = _super.call(this, props) || this;
        _this.getRowClassName = function (_a) {
            var _b;
            var index = _a.index;
            var _c = _this.props, classes = _c.classes, onRowClick = _c.onRowClick, rowCount = _c.rowCount, design = _c.design, prefixRow = _c.prefixRow;
            var newRowCount = rowCount + (prefixRow ? 1 : 0);
            return clsx_1.default(classes.tableRow, classes.flexContainer, (_b = {},
                _b[classes.tableRowHover] = index !== -1 && onRowClick != null && index < newRowCount,
                _b[classes.tableFirstRow] = design !== 'flat' && index === 0,
                _b[classes.tableLastRow] = design !== 'flat' && index === newRowCount - 1,
                _b[classes.tableRowNotEmpty] = design !== 'flat' && index < newRowCount && index >= 0,
                _b));
        };
        _this.cellRenderer = function (_a) {
            var _b;
            var cellData = _a.cellData, numeric = _a.numeric;
            var _c = _this.props, columns = _c.columns, classes = _c.classes, rowHeight = _c.rowHeight, onRowClick = _c.onRowClick;
            return (react_1.default.createElement(TableCell_1.default, { component: "div", className: clsx_1.default(classes.tableCell, classes.flexContainer, (_b = {},
                    _b[classes.noClick] = onRowClick == null,
                    _b)), variant: "body", colSpan: 0, style: { height: rowHeight, /*color: "#000"*/ fontSize: "13px", }, align: (numeric || false) ? 'right' : 'left' }, cellData));
        };
        _this.headerRenderer = function (_a) {
            var _b;
            var _c;
            var label = _a.label, numeric = _a.numeric, column = _a.column, total = _a.total;
            var _d = _this.props, headerHeight = _d.headerHeight, columns = _d.columns, classes = _d.classes, sortBy = _d.sortBy, sortDir = _d.sortDir, design = _d.design, onSort = _d.onSort;
            var newLabel = (_c = column.render) !== null && _c !== void 0 ? _c : column.label;
            return (react_1.default.createElement(TableCell_1.default, { component: "div", className: clsx_1.default(classes.tableCell, classes.flexContainer, classes.noClick, (_b = {},
                    _b[classes.tableHeaderFlat] = design === 'flat',
                    _b[classes.tableHeaderRound] = design === 'round',
                    _b)), variant: "head", style: { height: headerHeight, minWidth: 0, color: "#828282", fontWeight: 600, fontSize: "13px" }, align: (numeric || false) ? 'right' : 'left' }, (column.sortable && onSort)
                ? react_1.default.createElement(TableSortLabel_1.default, { direction: column.dataKey === sortBy ? sortDir : undefined, active: column.dataKey === sortBy ? true : false, onClick: function () {
                        var newSortBy = sortBy;
                        var newSortDir = sortDir;
                        if (newSortBy === column.dataKey) {
                            switch (newSortDir) {
                                case 'asc':
                                    if (!column.numeric) {
                                        newSortDir = 'desc';
                                    }
                                    else {
                                        newSortDir = undefined;
                                        newSortBy = undefined;
                                    }
                                    break;
                                case 'desc':
                                    if (!column.numeric) {
                                        newSortDir = undefined;
                                        newSortBy = undefined;
                                    }
                                    else {
                                        newSortDir = 'asc';
                                    }
                                    break;
                                case undefined:
                                    if (!column.numeric) {
                                        newSortDir = 'asc';
                                    }
                                    else {
                                        newSortDir = 'desc';
                                    }
                                    break;
                            }
                        }
                        else {
                            newSortBy = column.dataKey;
                            if (!column.numeric)
                                newSortDir = 'asc';
                            else
                                newSortDir = 'desc';
                        }
                        onSort(newSortBy, newSortDir);
                    } }, newLabel)
                : newLabel));
        };
        var selectedColumns = [];
        if (_this.props.saveKey) {
            var saved = localStorage.getItem("table_selected_" + _this.props.saveKey);
            if (saved) {
                selectedColumns = JSON.parse(saved);
            }
        }
        _this.state = {
            selectedColumns: selectedColumns,
        };
        return _this;
    }
    MuiVirtualizedTable.prototype.render = function () {
        var _this = this;
        var _a = this.props, classes = _a.classes, columns = _a.columns, rowHeight = _a.rowHeight, rowCount = _a.rowCount, headerHeight = _a.headerHeight, paddingRows = _a.paddingRows, prefixRow = _a.prefixRow, prefixRowHeight = _a.prefixRowHeight, rowGetter = _a.rowGetter, tableProps = __rest(_a, ["classes", "columns", "rowHeight", "rowCount", "headerHeight", "paddingRows", "prefixRow", "prefixRowHeight", "rowGetter"]);
        var options = columns.filter(function (item) { return item.optional; }).map(function (item) { return item.label; });
        var isMenu = !!columns.find(function (item) { return item.optional; });
        var columnWidthTotal = columns
            .filter(function (column) {
            if (!column.optional) {
                return true;
            }
            return _this.state.selectedColumns.includes(column.label);
        })
            .map(function (e) { return Math.max(e.width, 50); })
            .sum();
        return (react_1.default.createElement(react_virtualized_1.AutoSizer, null, function (_a) {
            var height = _a.height, width = _a.width;
            return (react_1.default.createElement(APStack_1.APStack, { style: { height: height, width: width } },
                react_1.default.createElement(APStack_1.APAlign, { align: 'fill', style: { overflowX: "auto", overflowY: "hidden" } },
                    react_1.default.createElement(react_virtualized_1.Table, __assign({ onRowsRendered: function (_a) {
                            var startIndex = _a.startIndex, stopIndex = _a.stopIndex;
                            if (stopIndex === rowCount + (paddingRows !== null && paddingRows !== void 0 ? paddingRows : 0) - 1) {
                                if (_this.props.onLoadMore)
                                    _this.props.onLoadMore();
                            }
                        }, height: height, width: Math.max(columnWidthTotal, width), rowHeight: function (_a) {
                            var index = _a.index;
                            return (prefixRow && index === 0) ? prefixRowHeight !== null && prefixRowHeight !== void 0 ? prefixRowHeight : rowHeight : rowHeight;
                        }, gridStyle: {
                            direction: 'inherit',
                        }, overscanRowCount: 20, headerHeight: headerHeight, className: classes.table }, tableProps, { rowClassName: _this.getRowClassName, rowCount: rowCount + (paddingRows !== null && paddingRows !== void 0 ? paddingRows : 0) + (prefixRow ? 1 : 0), rowGetter: function (_a) {
                            var index = _a.index;
                            if (prefixRow && index === 0) {
                                return prefixRow();
                            }
                            if (prefixRow) {
                                index--;
                            }
                            if (index < rowCount)
                                return rowGetter(index);
                            return {};
                        } }), columns
                        .filter(function (column) {
                        if (!column.optional) {
                            return true;
                        }
                        return _this.state.selectedColumns.includes(column.label);
                    })
                        .map(function (column, index, arr) {
                        var dataKey = column.dataKey, flex = column.flex, numeric = column.numeric, other = __rest(column, ["dataKey", "flex", "numeric"]);
                        return (react_1.default.createElement(react_virtualized_1.Column, __assign({ key: dataKey, headerRenderer: function (headerProps) {
                                return _this.headerRenderer(__assign(__assign({}, headerProps), { numeric: numeric, total: arr.length, column: column }));
                            }, flexGrow: flex, className: classes.flexContainer, cellRenderer: function (cellProps) {
                                return _this.cellRenderer({ cellData: cellProps.cellData, numeric: numeric });
                            }, dataKey: dataKey }, other)));
                    }))),
                isMenu && react_1.default.createElement(APStack_1.APAlign, { align: 'topRight', noClone: true, style: { marginTop: "12px", marginRight: "-8px" } },
                    react_1.default.createElement(APFilterMenu_1.APFilterMenu, { label: 'Columns', icon: react_1.default.createElement(SettingsOutlined_1.default /* htmlColor="#666" */, { fontSize: "small" }), options: [
                            {
                                title: "Select columns",
                                type: 'multi',
                                initialValue: _this.state.selectedColumns,
                                options: options.map(function (item) { return ({ label: item, value: item }); }),
                                onChange: function (v) {
                                    _this.setState({ selectedColumns: v });
                                    if (_this.props.saveKey)
                                        localStorage.setItem("table_selected_" + _this.props.saveKey, JSON.stringify(v));
                                }
                            }
                        ] }))));
        }));
    };
    MuiVirtualizedTable.defaultProps = {
        headerHeight: 48,
        rowHeight: 48,
        paddingRows: 0,
    };
    return MuiVirtualizedTable;
}(react_1.default.PureComponent));
// @ts-ignore
exports.APTable = styles_1.withStyles(styles)(MuiVirtualizedTable);
function useSortState(initSortBy, initSortDir) {
    var _a = react_1.useState(initSortBy), sortBy = _a[0], setSortBy = _a[1];
    var _b = react_1.useState(initSortDir), sortDir = _b[0], setSortDir = _b[1];
    function setSorting(newSortBy, newSortDir) {
        setSortBy(newSortBy);
        setSortDir(newSortDir);
    }
    return [sortBy, sortDir, setSorting];
}
exports.useSortState = useSortState;
